import styled from 'styled-components';
import {
  blue,
  red,
  white,
  silver,
  brightBlue,
  darkerGrey,
  tekoMedium,
  teko,
  tekoSemibold,
  tekoLight,
  openSans,
  roboto,
} from '../../../utils/theme';
import { mobile, tablet } from '../../../utils/breakpoints';
import { BackgroundContainer, Wrapper } from '../../../utils/atoms';

export const TicketsSection = styled(BackgroundContainer)``;

export const TicketsWrapper = styled(Wrapper)`
  padding: 85px 60px 120px 100px;
  text-align: left;
  max-width: 1360px;
  margin: 0 auto;

  @media(max-width: ${tablet.max}px) {
    padding: 85px 60px;
  }

  @media(max-width: ${mobile.max}px) {
    padding: 0;
  }

  .header-img {
    margin-left: -50px;

    @media(max-width: ${mobile.max}px) {
      width: 172px;
      margin-left: -27px;
    }
  }

  .shopify-buy__layout-horizontal {
    display: flex;

    @media(max-width: ${tablet.max}px) {
      flex-direction: column;
      padding: 30px 0;
      margin: 0 auto;
    }

    @media(max-width: ${mobile.max}px) {
      padding: 30px;
    }
  }

  .subtitle {
    margin-top: 24px;
    ${tekoMedium}
    font-size: 38px;
    color: ${blue};
    letter-spacing: 4px;

    @media(max-width: ${mobile.max}px) {
      font-size: 24px;
      letter-spacing: 2.53px;
    }
  }

  .description p, .description li {
    max-width: 580px;
    margin-top: 18px;
    ${openSans}
    font-size: 14px;
    color: ${darkerGrey};
    letter-spacing: 1.4px;
    line-height: 22px;

    @media(max-width: ${mobile.max}px) {
      font-size: 13px;
      letter-spacing: 1.52px;
    }
  }
  .description h2, .description h3, .description h4 {
    ${openSans}
  }

  .description li{
    
    margin-top: 3px;
  }
  
  .description ul{
    list-style: initial;
    list-style-position: inside;
  }

  .modal-toggle {
    cursor: pointer;
    ${openSans}
    font-size: 14px;
    color: ${blue};
    margin-top: 15px;
  }

  .tab-menu {
    margin-top: 105px;
    display: flex;
    justify-content: stretch;

    @media(max-width: ${mobile.max}px) {
      margin-top: 0;
    }

    .tab {
      cursor: pointer;
      flex-grow: 1;
      flex-basis: 12.5%;
      text-align: center;
      padding: 25px 22px;
      height: 94px;
      border-right: .5px solid ${silver};

      &:last-of-type {
        border-right: none;
      }

      p {
        font-size: 60px;
        line-height: 34px;
        ${tekoSemibold}
        color: ${silver};
        margin-bottom: 11px;
        letter-spacing: 2px;
        -ms-transform: skewX(-7deg); /* IE 9 */
        -webkit-transform: skewX(-7deg); /* Safari */
        transform: skewX(-7deg); /* Standard syntax */
      }

      h3 {
        ${tekoSemibold}
        font-size: 11px;
        color: ${silver};
        letter-spacing: 1.95px;
        text-align: center;
      }

      &.disabled {
        cursor: initial;
        padding: 30px 22px;
      }

      &.active {
        p {
          color: ${blue};
          text-shadow: -2px 0px ${brightBlue};
        }
  
        h3 {
          color: ${blue};
        }
      }
    }
  }
  
  .reserveButton {
    ${teko}
    display: block;
    padding: 0px 10px;
    margin: 0 auto 0 0;
    width: auto;
    cursor: pointer;
    text-transform: uppercase;
    font-size: 53px;
    line-height: 70px;
    height: 70px;
    letter-spacing: 6.26px;
    text-align: center;
    color: #0073FF;
    border: 2px solid #0073FF;
    white-space: nowrap;

    @media (max-width: ${tablet.max}px) {
      margin: auto;
      font-size: 36px;
      line-height: 1;
      height: auto;
      padding: 9px 5px 3px;
      width: auto;
      display: block;
    }

    &.disabled {
      color: ${silver};
      border-color: ${silver};
      cursor: initial;

      :hover {
        color: ${silver};
        border-color: ${silver};
        background: none;
      }
    }
  }

  .row {
    display: flex;
    justify-content: left;
    align-items: flex-end; 

    @media(max-width: ${tablet.max}px) {
      display: block;
      max-width: 580px;
      margin: 0 auto;
    }

    @media(max-width: ${mobile.max}px) {
      padding: 0 39px;
      margin: 0 auto;
    }

    &.disabled {
      .column .column-label {
        color: ${silver};
      }
  
      .column .value {
        color: ${silver};
      }

      button {
        cursor: initial;
      }
    }
  }

  .button-wrapper {
    @media(max-width: ${tablet.max}px) {
      float: right;
    }
  }

  .icon-button {
    display: inline-block;
    cursor: pointer;
    width: 45px;
    height: 45px;

    @media(max-width: ${tablet.max}px) {
      height: 33px;
      width: 33px;
    }

    @media(max-width: ${mobile.max}px) {
      height: 22px;
      width: 22px;
    }

    &.minus {
      margin-right: 20px;
      @media(max-width: ${mobile.max}px) {
        margin: 0;
      }
    }

    &.plus {
      margin-left: 20px;
      @media(max-width: ${mobile.max}px) {
        margin: 3px 0 0 0;
      }
    }
  }

  button {
    border: none;
    background: none;
    padding: 0;
  }

  .column {
    padding-top: 90px;

    @media(max-width: ${tablet.max}px) {
      padding-top: 0;
      padding-bottom: 50px;
      margin: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    
    .column-label {
      color: ${blue};
      ${tekoMedium}
      font-size: 38px;
      letter-spacing: 4px;
      margin-bottom: 25px;
      min-width: 200px;

      @media(max-width: ${tablet.max}px) {
        display: inline-block;
        min-width: 0;
      }

      @media(max-width: ${mobile.max}px) {
        font-size: 24px;
        letter-spacing: 2.11px;
        /* margin-top: 7px;
        margin-bottom: 18px; */
        margin: 0;
      }
    }

    &.column-reserve {
      display: flex;
      justify-content: flex-end;
      flex-direction: column;
    }

    &.column-quantity {
      margin-right: 100px;

      @media(max-width: ${tablet.max}px) {
        margin: 0;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }

      .value {
        width: 64px;
        text-align: center;
      }
    }

    &.column-amount {
      margin-right: 40px;

      @media(max-width: ${tablet.max}px) {
        margin: 0;
      }

      .value {
        width: 250px;
        letter-spacing: 4.04px;
      }
    }

    .value {
      ${teko}
      font-weight: bold;
      font-size: 70px;
      color: ${blue};
      line-height: 64px;
      display: inline-block;

      @media(max-width: ${tablet.max}px) {
        &.price {
          width: 150px;
          text-align: right;
          float: right;
        }
      }

      @media(max-width: ${mobile.max}px) {
        font-size: 37px;
        letter-spacing: 2.13px;
        line-height: 34.07px;
      }
    }

    &.reserve {
      background: ${red};
      padding: 0px;
      width: 204px;
      height: 50px;
      ${roboto}
      font-size: 15px;
      color: ${white};
      letter-spacing: 1.73px;
      text-align: center;
      line-height: 50px;
      border: none;
    }
  }

  .select {
    display: flex;

  }
`;

export const TicketsTopWrapper = styled.div`
  background-image: url('${({ img }) => img}');
  background-size: cover;
  background-position: top right;

  @media(max-width: ${tablet.max}px) {
    padding: 54px 39px;
  }
`;


export const MobileSelect = styled.div`
  background: ${blue};
  height: 172px;
  margin-bottom: 50px;
  text-align: center;
  padding: 40px 0 16px 0;
  position: relative;

  &.disabled {
    background: ${silver};
  }

  p {
    font-size: 70px;
    line-height: 44px;
    ${tekoSemibold}
    color: ${white};
    margin-bottom: 11px;
    letter-spacing: 2px;
    -ms-transform: skewX(-7deg); /* IE 9 */
    -webkit-transform: skewX(-7deg); /* Safari */
    transform: skewX(-7deg); /* Standard syntax */
    text-shadow: -2px 0px ${brightBlue};
  }

  h3 {
    ${teko}
    color: ${white};
    text-align: center;
    font-size: 14.3px;
    letter-spacing: 2.52px;
    margin-bottom: 22px;
  }

  .index {
    ${tekoLight}
    font-size: 15px;
    color: ${white};
    letter-spacing: 0.82px;
    text-align: center;

    @media(max-width: ${tablet.max}px) {
      margin-top: -4px;
    }
  }

  .arrow {
    position: absolute;
    top: calc(50% - 32px);
    cursor: pointer;

    &.prev {
      -moz-transform: scaleX(-1);
      -o-transform: scaleX(-1);
      -webkit-transform: scaleX(-1);
      transform: scaleX(-1);
      filter: FlipH;
      -ms-filter: "FlipH";
      left: 20px;
    }

    &.next {
      right: 20px;
    }
  }

  .coming-soon {
    height: 70px;
    margin-bottom: 22px;

    img {
      height: 61px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/tickets/styles/tickets.style.js